/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button, Group, Modal } from "@mantine/core";
import { useEffect, useState } from "react";
import { TEMPLATE_OPTIONS } from "../../../utils/utils";
interface selectOptionInterface {
  modalOpened: boolean;
  setModalOpened: (value: boolean) => void;
  onSelectedOption: (option: string) => void;
  template: any;
}
const SelectOptionAddToTemplateModal = (props: selectOptionInterface) => {
  const { modalOpened, setModalOpened, onSelectedOption, template } = props;
  const [canAddField, setCanAddField] = useState(false);
  const [canAddTextBox, setCanAddTextBox] = useState(false);
  useEffect(() => {
    if (modalOpened) {
      checkCanAddField();
      checkCanAddTextBox();
    }
  }, [modalOpened]);
  const checkCanAddField = () => {
    if (!template?.sections) {
      setCanAddField(false);
      return;
    }
    const sections = template.sections.items.filter(
      (section: any) =>
        (section.isSimple === false || section.isSimple === null) &&
        section?.subsections?.items.length > 0 &&
        section.name
    );
    setCanAddField(sections && sections.length > 0);
  };
  const checkCanAddTextBox = () => {
    if (!template?.sections) {
      setCanAddTextBox(false);
      return;
    }
    const sectionsSimple = template.sections.items.filter(
      (section: any) => section.isSimple === true
    );
    setCanAddTextBox(sectionsSimple?.length > 0);
  };
  const selectOption = (option: string) => {
    onSelectedOption(option);
    setModalOpened(false);
  };
  return (
    <Modal
      opened={modalOpened}
      onClose={() => setModalOpened(false)}
      title="Select option"
    >
      <Group mt="md">
        <Button
          w={250}
          mx={"auto"}
          onClick={() => selectOption(TEMPLATE_OPTIONS.SECTION)}
        >
          Add section
        </Button>
        <Button
          w={250}
          mx={"auto"}
          onClick={() => selectOption(TEMPLATE_OPTIONS.SUB_SECTION)}
        >
          Add subsection
        </Button>
        <Button
          w={250}
          mx={"auto"}
          disabled={!canAddField}
          onClick={() => selectOption(TEMPLATE_OPTIONS.FIELD)}
        >
          Add field
        </Button>
        <Button
          w={250}
          mx={"auto"}
          disabled={!canAddTextBox}
          onClick={() => selectOption(TEMPLATE_OPTIONS.TEXT_BOX)}
        >
          Add textbox
        </Button>
        <Button
          w={150}
          mx={"auto"}
          variant="default"
          onClick={() => setModalOpened(false)}
        >
          Cancel
        </Button>
      </Group>
    </Modal>
  );
};
export default SelectOptionAddToTemplateModal;
